import { browser } from '$app/environment';
import { experimentService } from '$lib/services/experiments/client';
import { getEnvironment } from '$lib/utils/environment';
import { setGlobalStore } from '$lib/stores/app/store';
import { qualifyExperiments } from '$lib/services/experiments';
import { AnalyticsService } from '$lib/services/analytics';

/** @type {import('./$types').LayoutLoad} */
export async function load() {
	if (browser) {
		await qualifyExperiments();
		setGlobalStore({ environment: getEnvironment() });
		await experimentService.initializeExperiments();

		// Ensure product experience is set from URL before conditions resolve
		AnalyticsService.setProductExperienceFromQuery();
	}
	return {};
}

export const prerender = true;
export const trailingSlash = 'always';
